// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"SecondLoader_loaderWrapper__AMvn+","loader":"SecondLoader_loader__Tkvke","spin":"SecondLoader_spin__CKN-w"};